<template>
  <v-app style="background-color: lightgray;">
    <AutoLogout></AutoLogout>
    <v-toolbar
      v-scroll="onScroll"
      prominent
      app
      height="100"
      class="col-xs-12"
      style="padding:0px !important;"
    >
      <v-layout row wrap>
        <v-flex xs12>
          <!-- <v-layout xs12 style="margin-bottom:8px;">
            <img
              v-if="restLogo!=''"
              class="smallImgWidth"
              style="width: 50px;height: 50px; margin-left:0px;max-width:80px;"
              :src="restLogo"
            />
            <img
              class="smallImgWidth"
              style="width: 50px;height: 50px; margin-left:auto;margin-right:0px;max-width:80px;float:right;"
              src="./assets/sirPos.png"
              @click="openSirPos()"
            />
          </v-layout>-->
          <v-layout xs12>
            <v-toolbar-title
              v-if="emptySearchValue && successLogin"
              class="headline"
              style="min-width:40px;margin-top:-5px;margin-right:5px;margin-left:-5px;"
              @click="toHomePage()"
            >
              <a v-if="restLogo==''">
                <v-icon style="font-size:40px;">home</v-icon>
              </a>
              <img
                v-if="restLogo!=''"
                class="smallImgWidth"
                style="width: 40px;height: 40px; margin-left:0px;"
                :src="restLogo"
              />
            </v-toolbar-title>
            <v-toolbar-title
              v-if="!emptySearchValue && successLogin"
              class="headline"
              style="min-width:40px;margin-right:5px;"
              @click="toMainPage()"
            >
              <a>
                <v-icon style="font-size:40px;margin-top:-10px;">arrow_back</v-icon>
              </a>
            </v-toolbar-title>
            <v-toolbar-title
              v-if="successLogin"
              class="headline"
              style="min-width:40px;margin-top:-5px;margin-right:5px;margin-left:-5px;"
            >
              <img
                class="smallImgWidth"
                style="width: 40px;height: 40px;"
                src="./assets/sirPos.png"
                @click="openSirPos()"
              />
            </v-toolbar-title>

            <div v-if="successLogin" class="col-xs-6 col-md-10" style="padding:0px;">
              <v-icon
                style="padding-left:5px;padding-top:6px;"
                @click="search(searchBarData)"
              >search</v-icon>
              <input
                v-model="searchBarData"
                type="text"
                style="margin-top:-38px;padding-left:30px;height:40px;"
                class="form-control searchBar"
                name="searchBarData"
                autocomplete="nope"
                :placeholder="$t('SearchIneOrder')"
                @input="searchBarData = $event.target.value"
                @keyup.enter="search(searchBarData)"
              />
            </div>

            <v-spacer v-if="successLogin"></v-spacer>
            <v-toolbar-title
              v-if="successLogin"
              class="headline"
              style="min-width:40px;margin-top:-5px;"
              @click="toShoppCart()"
            >
              <v-badge overlap color="transparent">
                <template v-slot:badge>
                  <div v-if="totalCartItemQty>0" class="badgeQty">
                    <p style="margin:0px;margin-top:-8px;text-align:center;">{{totalCartItemQty}}</p>
                  </div>
                  <div v-if="totalCartItemQty==0">
                    <p style="margin:0px;margin-top:-8px;"></p>
                  </div>
                </template>
                <a>
                  <img src="./assets/shopCartIcon.png" alt="logo" class="navImgTitle" />
                </a>
              </v-badge>
            </v-toolbar-title>
            <v-toolbar-title
              v-if="backEndAddOrdMode == false && successLogin"
              class="headline"
              style="min-width:40px;margin-top:-5px;"
            >
              <v-menu offset-y>
                <a slot="activator">
                  <img
                    src="./assets/loginIcon.png"
                    alt="logo"
                    class="navImgTitle"
                    @click="getUserCurrentInfo()"
                  />
                </a>

                <v-list>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <img src="./assets/sirPos.png" />
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>{{loginUName}}</v-list-tile-title>
                      <v-list-tile-sub-title style="margin-top:5px;">Balance Amount:</v-list-tile-sub-title>
                      <v-list-tile-sub-title
                        style="color:black;"
                      >{{userCurrentBalance | currency(userCurrentBalance)}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider style="margin-left:15px;margin-right:15px;margin-bottom:0px;"></v-divider>
                  <li style="margin:15px;width:100%;" @click="viewPurchaseHistory()">
                    <button>Purchase History</button>
                  </li>
                  <li style="margin:15px;color:red;width:100%;" @click="logOutUser()">
                    <button>Logout</button>
                  </li>
                </v-list>
              </v-menu>
            </v-toolbar-title>
            <v-toolbar-title
              v-if="backEndAddOrdMode && successLogin"
              style="width:45px;"
              @click="backToBackEndOrd()"
            >
              <button
                style="min-width:25px;border-radius:5px;background-color:red;color:white"
                class="btn"
              >X</button>
            </v-toolbar-title>

            <!-- /////////////////////////////////////////////////// -->
            <v-toolbar-title
              v-if="emptySearchValue && !successLogin"
              class="headline"
              style="min-width:40px;margin-top:-5px;margin-right:5px;margin-left:-5px;"
              @click="toHomePage()"
            >
              <a v-if="restLogo==''">
                <v-icon style="font-size:40px;">home</v-icon>
              </a>
              <img
                v-if="restLogo!=''"
                class="smallImgWidth"
                style="width: 40px;height: 40px; margin-left:0px;"
                :src="restLogo"
              />
            </v-toolbar-title>
            <v-toolbar-title
              v-if="!emptySearchValue && !successLogin"
              class="headline"
              style="min-width:40px;margin-right:5px;"
              @click="toMainPage()"
            >
              <a>
                <v-icon style="font-size:40px;margin-top:-10px;">arrow_back</v-icon>
              </a>
            </v-toolbar-title>
            <v-toolbar-title
              v-if="!successLogin"
              class="headline"
              style="min-width:40px;margin-top:-5px;margin-right:5px;margin-left:-5px;"
            >
              <img
                class="smallImgWidth"
                style="width: 40px;height: 40px;"
                src="./assets/sirPos.png"
                @click="openSirPos()"
              />
            </v-toolbar-title>
            <div v-if="!successLogin" class="col-xs-6 col-sm-9 col-lg-10" style="padding:0px;">
              <v-icon
                style="padding-left:5px;padding-top:6px;"
                @click="search(searchBarData)"
              >search</v-icon>
              <input
                v-model="searchBarData"
                type="text"
                style="margin-top:-38px;padding-left:30px;height:40px;"
                class="form-control searchBar"
                name="searchBarData"
                autocomplete="nope"
                placeholder="Search in eOrder"
                @input="searchBarData = $event.target.value"
                @keyup.enter="search(searchBarData)"
              />
            </div>
            <v-spacer v-if="!successLogin"></v-spacer>
            <v-toolbar-title
              v-if="!successLogin"
              class="headline"
              style="min-width:40px;margin-top:-5px;"
              @click="toShoppCart()"
            >
              <v-badge overlap color="transparent">
                <template v-slot:badge>
                  <div v-if="totalCartItemQty>0" class="badgeQty">
                    <p style="margin:0px;margin-top:-8px;text-align:center;">{{totalCartItemQty}}</p>
                  </div>
                  <div v-if="totalCartItemQty==0">
                    <p style="margin:0px;margin-top:-8px;"></p>
                  </div>
                </template>
                <a>
                  <img src="./assets/shopCartIcon.png" alt="logo" class="navImgTitle" />
                </a>
              </v-badge>
            </v-toolbar-title>
            <v-toolbar-title
              v-if="(needLoginAndPay == true) && (backEndAddOrdMode == false) && !successLogin"
              style="min-width:35px;margin-top:-5px;"
              @click="goLogin()"
            >
              <button class="btn">Login</button>
            </v-toolbar-title>
            <v-toolbar-title
              v-if="backEndAddOrdMode && !successLogin"
              style="width:45px;"
              @click="backToBackEndOrd()"
            >
              <button
                style="min-width:25px;border-radius:5px;background-color:red;color:white"
                class="btn"
              >X</button>
            </v-toolbar-title>
          </v-layout>
        </v-flex>
        <v-layout
          v-if="listOfCat.length>0"
          xs12
          style="background-color:lightgray;margin:0px;margin-top:5px;"
        >
          <v-flex xs12>
            <v-card>
              <!-- <v-card-title style="padding-bottom: 0px;padding-top: 5px;">
                <h3>Category</h3>
              </v-card-title>-->
              <v-tabs v-model="catNameIndex" fixed-tabs show-arrows>
                <h5 style="margin:auto;margin-right:12px;">Category</h5>
                <v-tab
                  v-for="(catName,i) in listOfCatForSelect"
                  :key="i"
                  :href="'#tab-' + i"
                  @click="selectCat(catName,i,searchBarData)"
                >{{ catName }}</v-tab>
              </v-tabs>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-toolbar>

    <v-container class="noPadding" style="margin-top:105px;">
      <!-- //slider -->
      <v-carousel v-if="emptySearchValue && !noBanner" class="carousel">
        <v-carousel-item v-for="(itemSldImg, i) in itemSlideImg" :key="i">
          <img v-if="itemSldImg.ko == ''" class="slideImg" :src="itemSldImg.kx" />
          <img
            v-if="itemSldImg.ko != ''"
            class="slideImg"
            :src="itemSldImg.kx"
            @click="slideImgLink(itemSldImg.ko)"
          />
        </v-carousel-item>
      </v-carousel>
      <!-- <div v-if="listOfCat.length>0">
        <v-card>
          <v-card-title style="padding-bottom: 0px;padding-top: 5px;">
            <h3>Category</h3>
          </v-card-title>
          <v-tabs v-model="catNameIndex" fixed-tabs show-arrows>
            <v-tab
              v-for="(catName,i) in listOfCatForSelect"
              :key="i"
              :href="`#tab-${i}`"
              @click="selectCat(catName,i)"
            >{{ catName }}</v-tab>
          </v-tabs>
        </v-card>
      </div>-->

      <v-layout v-if="noItemFound">
        <div style="padding:30px;float:center;">
          <!-- <h3>No Item Found!</h3> -->
          <h3>{{NoItemMsg}}</h3>
        </div>
      </v-layout>

      <v-layout class="col-xs-12 noPadding">
        <v-flex style="padding:0px;">
          <div v-for="cat in listOfCat" :key="cat.ID" style="padding-left:5px;padding-right:5px;">
            <v-container
              v-if="cat.catAllData.length>0"
              fluid
              grid-list-xs
              class="noPadding"
              style="background-color:lightgray;"
            >
              <!-- <v-tabs fixed-tabs style="margin-bottom:-25px;">
                <v-tab v-for="n in 13" :key="n">Item {{ n }}</v-tab>
              </v-tabs>-->
              <h3 v-if="selectedCatName == ''" class="containTitleWidth">{{cat.catName}}</h3>
              <v-data-iterator :items="cat.catAllData" content-tag="v-layout" hide-actions row wrap>
                <template slot="item" slot-scope="props">
                  <v-layout class="itemListLayout">
                    <button
                      v-if="props.item.soldOut == false"
                      class="btn mainListItemBtn"
                      style="width:100%;height:auto;padding:0px;"
                      @click="openItemDetail(props.item.itmId)"
                    >
                      <v-card style="width:100%;height:auto;">
                        <v-card-title style="padding:0px;">
                          <div class="imageContainer imgWidth">
                            <img
                              class="smallImgWidth"
                              style="width: 100%;height: auto; margin:auto;"
                              :src="props.item.itmTNFileUrl"
                            />
                            <!-- @click="showFullImage(props.index)" -->
                          </div>
                        </v-card-title>

                        <!-- <v-divider></v-divider> -->
                        <v-card-title
                          style="padding:5px;padding-bottom:0px;min-height:35px;"
                          class="subheading font-weight-bold"
                        >
                          <p
                            style="margin:0px;text-align:left;overflow: hidden;white-space: nowrap; text-overflow: ellipsis;"
                          >{{ props.item.itmName }}</p>
                        </v-card-title>
                        <v-card-title
                          class="subheading font-weight-bold"
                          style="padding:0px 0px 0px 5px;min-height:23px;"
                        >
                          <p v-if="props.item.sellingFast" class="sellingFast">Selling Fast</p>
                        </v-card-title>
                        <v-card-title class="subheading font-weight-bold itemPriceColor">
                          <p style="margin:0px;text-align:left;">RM {{ props.item.itemPrice }}</p>
                        </v-card-title>
                      </v-card>
                    </button>
                    <button
                      v-if="props.item.soldOut"
                      class="btn mainListItemBtn"
                      style="width:100%;height:auto;padding:0px;"
                      @click="openItemDetail(props.item.itmId)"
                    >
                      <v-card style="width:100%;height:auto;">
                        <v-card-title style="padding:0px;">
                          <div class="imageContainer imgWidth">
                            <div style="position:relative;">
                              <img
                                class="smallImgWidth"
                                style="width: 100%;height: auto; margin:auto;"
                                :src="props.item.itmTNFileUrl"
                              />
                              <img
                                class="smallImgWidth"
                                style="width: 100%;height: auto; margin:auto;position: absolute; top: 0; right: 0;"
                                src="./assets/soldOut.png"
                              />
                            </div>

                            <!-- @click="showFullImage(props.index)" -->
                          </div>
                        </v-card-title>

                        <!-- <v-divider></v-divider> -->
                        <v-card-title
                          style="padding:5px;padding-bottom:0px;min-height:35px;"
                          class="subheading font-weight-bold"
                        >
                          <p style="margin:0px;text-align:left;">{{ props.item.itmName }}</p>
                        </v-card-title>
                        <v-card-title
                          class="subheading font-weight-bold"
                          style="padding:0px 0px 0px 5px;min-height:23px;"
                        >
                          <p v-if="props.item.sellingFast" class="sellingFast">Selling Fast</p>
                        </v-card-title>
                        <v-card-title class="subheading font-weight-bold itemPriceColor">
                          <p style="margin:0px;text-align:left;">RM {{ props.item.itemPrice }}</p>
                        </v-card-title>
                      </v-card>
                    </button>
                  </v-layout>
                </template>
              </v-data-iterator>
            </v-container>
          </div>
        </v-flex>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="userLoginDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline lighten-2"
              style="padding-top: 10px; padding-bottom: 0px;"
            >Login</v-card-title>
            <v-card-text style="padding:10px;">
              <v-container grid-list-md style="padding-top: 0px;padding-bottom: 0px;">
                <v-layout wrap>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">Tel No :</h4>
                    <input
                      v-model="loginUName"
                      class="form-control"
                      name="loginUName"
                      required
                      type="text"
                      @input="loginUName = $event.target.value"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <h4 class="userProfileTxt">Password :</h4>
                    <input
                      v-model="loginUPswd"
                      class="form-control"
                      required
                      type="password"
                      name="loginUPswd"
                      @input="loginUPswd = $event.target.value"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
              <span v-if="loginError != ''" class="txtClrRed">{{loginError}}</span>
              <br />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" flat @click="userLoginDialog = false">Close</v-btn>
              <v-btn color="primary" flat @click="getUserDataToLogin()">Login</v-btn>
            </v-card-actions>

            <!-- <v-container style="padding-top:0px;">
              <restCardp9 v-if="kp == 'p9'"></restCardp9>
            </v-container>-->
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout class="text-xs-center">
        <v-dialog v-model="clearCartDataDialog" persistent width="1000">
          <v-card>
            <v-card-title
              class="headline lighten-2"
              primary-title
              style="color: white;background: red;"
            >Warning !!!</v-card-title>
            <v-card-text>
              <h3>Are you sure you want to return to the home page?</h3>
              <h4 style="color:red;">All your shopping cart item records will be cleared!</h4>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="default" flat @click="sureToClearCart()">Yes</v-btn>
              <v-btn color="primary" flat @click="clearCartDataDialog = false">No</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <VersionDialog v-if="versionError"></VersionDialog>
    </v-container>
  </v-app>
</template>

<script>
import $ from 'jquery'
import JS from './JsonService'
import { enumEOrder_MchOption } from './JsonKey.js'
// import restCardp9 from './RestCardp9'
import VersionDialog from '../src/VersionNotMatchDialog'
import globalVar from './GlobalVar.js'
// import JsonServiceForToken from './JsonServiceForToken.js'
import Vue from 'vue'
import VueSession from 'vue-session'
import AutoLogout from './AutoLogout'
Vue.use(VueSession, { persist: true })
export default {
  components: {
    // restCardp9,
    AutoLogout,
    VersionDialog
  },
  filters: {
    currency(amount) {
      const amt = Number(amount)
      return amt.toFixed(2)
    }
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['loginKey'],
  data() {
    return {
      userCurrentBalance: 0,
      allCartItem: [],
      loginDetail: [],
      tokenKey: '',
      loginUName: '',
      loginUPswd: '',
      userIdFromServer: '',
      uEmail: '',
      uMemo: '',
      loginError: '',
      needLoginAndPay: false,
      clientDisplayName: '',
      successLogin: false,
      totalCartItemQty: 0,
      // mName: '',
      CatName: '',
      searchedData: [],
      selectedCatName: '',
      kp: '',
      la: '',
      le: '',
      searchedValue: '',
      emptySearchValue: true,
      searchBarData: '',
      listItemDialog: false,
      itemSlideImg: [],
      noItemFound: false,
      userLoginDialog: false,
      listOfCat: [],
      listOfCatForSelect: [],
      sendRefId: 0,
      clearCartDataDialog: false,
      noBanner: true,
      catNameIndex: 'tab-0',
      currentPositionHight: 0,
      height: 0,
      getItemListType: 3,
      backEndAddOrdMode: false,
      ktnId: 0,
      needLoadSearch: true,
      restLogo: '',
      versionError: false,
      NoItemMsg: 'No Item Found'
      // ListOfItemInfo: [],
      // ListOfItemPrice: [],
      // ListOfItemProp: [],
      // ListOfCatName: [],
      // listOfItem: [],
      // selectedCatName: '',
      // itemName: '',
      // itemSizeName: '',
      // singlePrice: Number,
      // listOfSize: [],
      // listOfProp: [],
      // itemQty: Number,
      // InfoOfCart: [],
      // szMsg: false,
      // szMsgText: '',
      // memo: '',
      // OrderPayment: [],
      // paymentItem: [],
      // totalPayQty: 0,
      // totalPayment: 0,
      // snackbar: false,
      // y: 'top',
      // timeout: 1500,
      // emptyItmDialog: false,
      // clearAllDataDialog: false,
      // showFullImageDialog: false,
      // bigPic: '',
      // onlyOneSizeToSelect: false,
      // noProp: false,
      // selectedProp: [],
      // selectedPropPrice: [],
      // propItemPrice: 0
    }
  },
  created: function() {
    history.pushState(null, null, location.href)
    // history.back()
    // history.forward()
    window.onpopstate = function() {
      //this.$router
      history.go(1)
    }
    // if (sessionStorage.getItem('successLogin')) {
    //   const value = sessionStorage.getItem('successLogin')
    //   var status = JSON.parse(value)
    //   this.successLogin = status.successLogin
    //   console.log('login status: ', this.successLogin)
    //   const tokenKey = sessionStorage.getItem('LoginToken')
    //   this.tokenKey = tokenKey
    //   console.log(tokenKey)
    //   this.getUserDataByToken()
    // }

    // if (this.successLogin == false || this.successLogin == undefined) {
    //   this.successLogin = false
    //   sessionStorage.setItem(
    //     'successLogin',
    //     JSON.stringify({
    //       successLogin: false
    //     })
    //   )
    //   console.log('Token from daccess : ', this.loginKey)
    //   sessionStorage.setItem('LoginToken', this.loginKey)
    //   this.tokenKey = this.loginKey
    //   this.getUserDataByToken()
    // }

    // if (this.loginKey != '' && this.loginKey != undefined) {
    //   this.successLogin = false
    //   sessionStorage.setItem(
    //     'successLogin',
    //     JSON.stringify({
    //       successLogin: false
    //     })
    //   )
    //   console.log('Token from daccess : ', this.loginKey)
    //   sessionStorage.setItem('LoginToken', this.loginKey)
    //   this.tokenKey = this.loginKey
    //   this.getUserDataByToken()
    // } else {
    //   if (sessionStorage.getItem('successLogin')) {
    //     const value = sessionStorage.getItem('successLogin')
    //     var status = JSON.parse(value)
    //     this.successLogin = status.successLogin
    //     console.log('login status: ', this.successLogin)
    //   }

    //   if (this.successLogin) {
    //     const tokenKey = sessionStorage.getItem('LoginToken')
    //     this.tokenKey = tokenKey
    //     console.log(tokenKey)
    //     this.getUserDataByToken()
    //   } else {
    //     this.successLogin = false
    //     sessionStorage.setItem(
    //       'successLogin',
    //       JSON.stringify({
    //         successLogin: false
    //       })
    //     )
    //     console.log('Token from daccess : ', this.loginKey)
    //     sessionStorage.setItem('LoginToken', this.loginKey)
    //     this.tokenKey = this.loginKey
    //     this.getUserDataByToken()
    //   }
    // }

    if (sessionStorage.getItem('successLogin')) {
      const value = sessionStorage.getItem('successLogin')
      var status = JSON.parse(value)
      if (status.successLogin) {
        this.successLogin = status.successLogin
        this.loginUName = status.clientDisplayName
        this.loginUPswd = status.clientMobileNo
        this.userIdFromServer = status.clientId
        this.uEmail = status.clientEmail
        this.uMemo = ''
        console.log('login status: ', status)
      }
    }

    if (sessionStorage.getItem('NoItemMsg') != '') {
      this.NoItemMsg = sessionStorage.getItem('NoItemMsg')
    }

    const refIdValue = sessionStorage.getItem('haveRefId')
    this.sendRefId = refIdValue
    console.log(this.sendRefId)
    if (this.sendRefId == undefined || this.sendRefId == '') {
      this.sendRefId = 0
    }

    const valueQty = sessionStorage.getItem('TotalCartItemQty')
    this.totalCartItemQty = valueQty
    // console.log(this.totalCartItemQty)

    const key = 'searchedInfo'
    if (sessionStorage.getItem(key)) {
      const value = sessionStorage.getItem(key)
      // console.log(value)
      this.searchedData = JSON.parse(value)
      console.log(this.searchedData)
      this.kp = this.searchedData.kp
      this.la = this.searchedData.la
      this.le = this.searchedData.le
      if (this.searchedData.mv != '') {
        this.restLogo = JS.checkImg(this.searchedData.mv)
      }

      if (this.le == '') {
        this.le = 0
      }
      this.needLoginAndPay = this.needPayment(this.searchedData.ol)
      //console.log(this.kp, this.la, this.le, this.needLoginAndPay)
    }

    // if (this.kp == 'p9' && this.successLogin == false) {
    //   var a = sessionStorage.getItem('fromSearch')
    //   console.log(a)
    //   if (a == 'true') {
    //     this.userLoginDialog = true
    //   } else {
    //     this.userLoginDialog = false
    //   }
    // }

    if (sessionStorage.getItem('sltCatName')) {
      const valueCatName = JSON.parse(sessionStorage.getItem('sltCatName'))
      console.log(valueCatName)
      this.selectedCatName = valueCatName.name
      this.catNameIndex = valueCatName.catNameIndex
      // this.onFilterCatName(this.selectedCatName)
    } else {
      this.selectedCatName = ''
      this.catNameIndex = 'tab-0'
    }

    var backEndMode = sessionStorage.getItem('backEndAddOrd')
    console.log(backEndMode)
    if (
      backEndMode == 'false' ||
      backEndMode == undefined ||
      backEndMode == null
    ) {
      this.backEndAddOrdMode = false
    } else if (backEndMode == 'true') {
      this.backEndAddOrdMode = true
      this.ktnId = sessionStorage.getItem('backEndAddOrdKtnId')
      console.log('KTN Id: ', this.ktnId)
    }

    var needLoadSearch = sessionStorage.getItem('needLoadSearch')
    this.needLoadSearch = needLoadSearch

    var searchValue = sessionStorage.getItem('searchedValue')
    console.log(searchValue)
    if (searchValue == '' || searchValue == undefined) {
      this.emptySearchValue = true
      this.searchedValue = ''
      this.getSlideImg()
      this.getItemList()
    } else {
      this.emptySearchValue = false
      this.searchedValue = searchValue
      this.searchBarData = searchValue
      this.getItemList()
    }

    // const value = sessionStorage.getItem('cart')
    // console.log(value)
    // if (value != undefined) {
    //   var newcartItem = JSON.parse(value)
    //   console.log('new', newcartItem)
    //   this.InfoOfCart = newcartItem

    //   for (let i = 0; i < this.InfoOfCart.length; i++) {
    //     this.totalPayQty = this.totalPayQty + this.InfoOfCart[i].qty
    //     this.totalPayment = this.totalPayment + this.InfoOfCart[i].totalPrice
    //   }

    //   this.paymentItem.totalPayQty = this.totalPayQty
    //   this.paymentItem.totalPayment = this.totalPayment
    //   this.OrderPayment.push(this.paymentItem)
    // }
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    openSirPos() {
      var sirPos = 'http://mpos.us/'
      window.open(sirPos)
    },
    onScroll(e) {
      this.height = e.target.doctype.ownerDocument.documentElement.scrollTop
      //console.log(e)
      //console.log(this.height)
    },
    needPayment(lLevel) {
      console.log(lLevel)
      console.log([enumEOrder_MchOption.NeedPayment])
      console.log((lLevel & [enumEOrder_MchOption.NeedPayment]) != 0)
      console.log((lLevel & [enumEOrder_MchOption.AskLoginBeforeCheckout]) != 0)
      return (lLevel & [enumEOrder_MchOption.NeedPayment]) != 0
    },
    slideImgLink(link) {
      console.log(link)
      if (link != '') {
        window.open(link, '_self')
      }
    },
    getSlideImg() {
      this.versionError = false
      var version = sessionStorage.getItem('version')
      const url = 'Order/GetBannerList'
      const parameter = {
        av: version,
        kp: this.kp
      }
      console.log('parameter: ', parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log('data : ', response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ListOfBanner.length == 0) {
              this.noBanner = true
            } else {
              this.noBanner = false
              for (let i = 0; i < response.data.ListOfBanner.length; i++) {
                response.data.ListOfBanner[i].kx = JS.checkImg(
                  response.data.ListOfBanner[i].kx
                )
              }
              this.itemSlideImg = response.data.ListOfBanner
              console.log('data : ', this.itemSlideImg)
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.versionError = false
        })
    },
    selectCat(value, i, searchBarData) {
      this.search(searchBarData)
      if (value == 'All') {
        this.selectedCatName = ''
      } else {
        this.selectedCatName = value
      }

      sessionStorage.setItem(
        'sltCatName',
        JSON.stringify({
          name: this.selectedCatName,
          catNameIndex: 'tab-' + i
        })
      )

      sessionStorage.setItem('mainlistPosition', 0)
      this.getItemList()
    },
    search(value) {
      console.log(value)
      if (value != '' && value != undefined) {
        if (this.searchedValue != value) {
          if (!value.replace(/\s/g, '').length) {
            this.toMainPage()
          } else {
            this.emptySearchValue = false
            this.searchedValue = value
            this.getItemList()
          }
        }
      } else {
        this.toMainPage()
      }
    },
    toMainPage() {
      this.emptySearchValue = true
      this.searchedValue = ''
      this.searchBarData = ''
      this.getSlideImg()
      this.getItemList()
    },
    toHomePage() {
      // var needLoadSearch = sessionStorage.getItem('needLoadSearch')
      // if (needLoadSearch == 'true') {
      //   this.clearCartDataDialog = true
      // }
      this.clearCartDataDialog = true
    },
    sureToClearCart() {
      if (globalVar.mode == 'normal') {
        this.$router.replace('/')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'Search', params: { mchdCode: mchCd } })
      }
    },
    foodCourtOption(lLevel) {
      return (lLevel & [enumEOrder_MchOption.FoodCourtMode]) != 0
    },
    getItemList() {
      this.versionError = false
      const url = 'Order/GetItemList'

      var needLoadSearch = sessionStorage.getItem('needLoadSearch')
      console.log(needLoadSearch)
      const key = 'searchedInfo'
      if (sessionStorage.getItem(key)) {
        const value = sessionStorage.getItem(key)
        this.searchedData = JSON.parse(value)
        let foodCourtMode = this.foodCourtOption(this.searchedData.ol)

        if (foodCourtMode) {
          this.getItemListType = 5
        } else {
          this.getItemListType = 3
        }
      }

      if (this.selectedCatName == '' || this.selectedCatName == undefined) {
        this.selectedCatName == ''
      }

      var parameter = {}
      var version = sessionStorage.getItem('version')
      if (this.ktnId == 0) {
        parameter = {
          av: version,
          kp: this.kp,
          la: this.la,
          le: this.le,
          mr: this.selectedCatName, //if "" = All //CatName
          dv: this.searchedValue,
          gm: this.getItemListType
        }
      } else {
        parameter = {
          av: version,
          kp: this.kp,
          rd: this.ktnId,
          la: this.la,
          le: this.le,
          mr: this.selectedCatName, //if "" = All //CatName
          dv: this.searchedValue,
          gm: this.getItemListType
        }
      }

      console.log('parameter: ', parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log('data : ', response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            sessionStorage.setItem('searchedValue', this.searchedValue)
            this.getCombineData(response.data)
            // this.getItemInfo(response.data)
            // this.getItemPrice(response.data)
            // this.getItemProp(response.data)
            // this.getCatName(response.data)
          }
        })
        .catch(error => {
          this.versionError = false
          console.log(error)
        })
    },
    // getUserDataByToken() {
    //   console.log(this.tokenKey)
    //   if (this.validURL(this.tokenKey)) {
    //     let url = 'OfficialAccount/GetOADecrypt'
    //     let para = {
    //       token: this.tokenKey
    //     }
    //     JsonServiceForToken.request(url, para)
    //       .then(res => {
    //         console.log(res.data)
    //         if (res.data.mb != '') {
    //           this.loginUName = res.data.mb
    //           this.loginUPswd = res.data.code
    //           this.Login()
    //         } else {
    //           console.log(res.data)
    //           this.errorToken = true
    //         }
    //       })
    //       .catch(err => {
    //         console.log('err', err)
    //       })
    //   }
    // },
    // validURL(tokenKey) {
    //   console.log('Token: ', tokenKey)
    //   if (
    //     tokenKey === null ||
    //     tokenKey === '' ||
    //     typeof tokenKey === 'undefined'
    //   ) {
    //     return false
    //   }
    //   return true
    // },
    // Login() {
    //   if (this.loginUName.length < 1) {
    //     this.loginError = 'User Name Cannot be blank'
    //   } else if (this.loginUPswd.length < 1) {
    //     this.loginError = 'Password Cannot be blank'
    //   } else {
    //     const url = 'Order/Login'
    //     const para = {
    //       av: '1',
    //       kp: 'caeldeon', //caeldeon === mcode
    //       x: this.loginUName,
    //       on: this.loginUPswd
    //     }
    //     JS.request(url, para)
    //       .then(res => {
    //         console.log('res: ', res.data)
    //         if (res.data.ez) {
    //           if (res.data.ez != undefined || res.data.ez != '') {
    //             console.log('successLogin')
    //             this.successLogin = true

    //             sessionStorage.setItem(
    //               'successLogin',
    //               JSON.stringify({
    //                 successLogin: true,
    //                 clientDisplayName: res.data.ez,
    //                 clientMobileNo: res.data.az,
    //                 clientAddress: res.data.en,
    //                 clientId: res.data.m,
    //                 clientEmail: res.data.ly
    //               })
    //             )
    //             this.clientDisplayName = res.data.ez
    //           } else {
    //             this.successLogin = false
    //             console.log('!successLogin')
    //           }
    //         } else {
    //           this.successLogin = false
    //           console.log('!successLogin')
    //         }
    //       })
    //       .catch(err => {
    //         this.successLogin = false
    //         console.log('!successLogin')
    //         console.log('err', err)
    //       })
    //   }
    // },
    getCombineData(data) {
      this.listOfCat = []
      this.listOfCatForSelect = ['All']
      this.noItemFound = false
      if (data.ListOfItem.length == 0) {
        this.noItemFound = true
      }
      for (let i = 0; i < data.ListOfCat.length; i++) {
        const itemCat = []
        // this.listOfCat.push(itemCat)
        this.listOfItem = []
        for (let j = 0; j < data.ListOfItem.length; j++) {
          const itemInfo = []
          if (data.ListOfCat[i].mr == data.ListOfItem[j].mr) {
            if (data.ListOfItem[j].kw == '' || data.ListOfItem[j].kw == null) {
              var defaultImg = require('./assets/ImgNotFound.png')
              data.ListOfItem[j].kw = defaultImg
            } else {
              data.ListOfItem[j].kw = JS.checkImg(data.ListOfItem[j].kw)
            }

            itemInfo.catName = data.ListOfItem[j].mr
            itemInfo.itmName = data.ListOfItem[j].ku
            itemInfo.itmTNFileUrl = data.ListOfItem[j].kw
            itemInfo.itmId = data.ListOfItem[j].kt
            itemInfo.soldOut = data.ListOfItem[j].oc
            itemInfo.sellingFast = data.ListOfItem[j].sd
            itemInfo.itemPrice = data.ListOfItem[j].lp
            this.listOfItem.push(itemInfo)
          }
        }
        itemCat.catIndex = data.ListOfCat[i].fk
        itemCat.catName = data.ListOfCat[i].mr
        itemCat.catAllData = this.listOfItem
        this.listOfCat.push(itemCat)
        this.listOfCatForSelect.push(itemCat.catName)
      }
      console.log('Item Cat data: ', this.listOfCat)
      // console.log('Item Info data: ', this.listOfItem)
      console.log(this.listOfCatForSelect)
      this.setPosition()
    },
    setPosition() {
      if (sessionStorage.getItem('needBackPrevPosition')) {
        var needPrePosition = sessionStorage.getItem('needBackPrevPosition')
        console.log(needPrePosition)
        if (needPrePosition == 'true') {
          if (sessionStorage.getItem('mainlistPosition')) {
            var position = sessionStorage.getItem('mainlistPosition')
            console.log(position)
            //window.scrollTo(0, 500)
            $('html, body').animate({ scrollTop: position }, { duration: 10 })
          }
        }
      }
    },
    getUserDataToLogin() {
      this.versionError = false
      if (this.loginUName.length < 1) {
        this.loginError = 'Tel No Cannot be blank'
      } else if (this.loginUPswd.length < 1) {
        this.loginError = 'Password Cannot be blank'
      } else {
        var version = sessionStorage.getItem('version')
        const url = 'Order/Login'
        const para = {
          av: version,
          kp: this.kp,
          x: this.loginUName,
          on: this.loginUPswd
        }
        console.log(para)
        JS.request(url, para)
          .then(res => {
            console.log('res: ', res.data)
            sessionStorage.setItem('fromSearch', false)
            if (
              res.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
              res.data == 'Version Not Match'
            ) {
              this.versionError = true
            } else {
              this.versionError = false
              if (
                res.data ==
                  '@#=#@@=$#49@=$#Invalid Username Or Password@=$#0' ||
                res.data == 'Invalid Username Or Password'
              ) {
                this.loginError = 'Invalid Username Or Password'
              }
              if (res.data.ez) {
                if (res.data.ez != undefined || res.data.ez != '') {
                  this.userCurrentBalance = res.data.re
                  this.userIdFromServer = res.data.m
                  this.loginUName = res.data.ez
                  this.userLoginDialog = false
                  console.log('successLogin')
                  this.successLogin = true

                  sessionStorage.setItem(
                    'loginData',
                    JSON.stringify({
                      name: this.loginUName,
                      pwd: this.loginUPswd
                    })
                  )

                  sessionStorage.setItem(
                    'successLogin',
                    JSON.stringify({
                      successLogin: true,
                      clientDisplayName: res.data.ez,
                      clientMobileNo: res.data.az,
                      clientAddress: res.data.en,
                      clientId: res.data.m,
                      clientEmail: res.data.ly,
                      clientBalancePoint: res.data.re,
                      clientAddr1: res.data.rf,
                      clientAddr2: res.data.rg,
                      clientAddr3: res.data.rh,
                      clientCity: res.data.ri,
                      clientPostcode: res.data.rj,
                      clientState: res.data.rk,
                      clientCountryName: res.data.hm
                    })
                  )
                  this.clientDisplayName = res.data.ez
                } else {
                  this.successLogin = false
                  console.log('!successLogin')
                }
              } else {
                this.successLogin = false
                console.log('!successLogin')
              }
            }
          })
          .catch(err => {
            this.versionError = false
            this.successLogin = false
            console.log('!successLogin')
            console.log('err', err)
          })
      }
    },
    onFilterCatName(event) {
      this.selectedCatName = event
      console.log(this.selectedCatName)
      if (this.selectedCatName != '') {
        // --------------call serve-------------------------
        const key = 'searchedInfo'
        if (sessionStorage.getItem(key)) {
          const value = sessionStorage.getItem(key)
          // console.log(value)
          this.searchedData = JSON.parse(value)
          // console.log(this.searchedData)
          this.kp = this.searchedData.kp
          this.la = this.searchedData.la
          this.le = this.searchedData.le
          console.log(this.kp, this.la, this.le)
        }

        const url = 'Order/GetItemList'

        if (this.selectedCatName == 'All') {
          this.CatName = ''
        } else {
          if (this.CatName == '' || this.CatName == undefined) {
            this.CatName = this.selectedCatName
          } else if (this.selectedCatName == this.CatName) {
            this.CatName = this.selectedCatName
          } else if (this.selectedCatName != this.CatName) {
            this.CatName = this.selectedCatName
          }
        }

        var needLoadSearch = sessionStorage.getItem('needLoadSearch')
        if (needLoadSearch == 'true') {
          this.getItemListType = 3
        } else if (needLoadSearch == 'false') {
          this.getItemListType = 5
        }

        this.versionError = false
        var parameter = {}
        var version = sessionStorage.getItem('version')
        if (this.ktnId == 0) {
          parameter = {
            av: version,
            kp: this.kp,
            la: this.la,
            le: this.le,
            mr: '',
            dv: this.searchedValue,
            gm: this.getItemListType
          }
        } else {
          parameter = {
            av: version,
            kp: this.kp,
            rd: this.ktnId,
            la: this.la,
            le: this.le,
            mr: '',
            dv: this.searchedValue,
            gm: this.getItemListType
          }
        }

        console.log(parameter)

        JS.request(url, parameter)
          .then(response => {
            console.log('data : ', response.data)
            if (
              response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
              response.data == 'Version Not Match'
            ) {
              this.versionError = true
            } else {
              this.versionError = false
              this.getItemInfo(response.data)
              this.getItemPrice(response.data)
              // this.getCatName(response.data)
            }
          })
          .catch(error => {
            this.versionError = false
            console.log(error)
          })
      }
    },
    showFullImage(index) {
      console.log(index)
      this.bigPic = this.ListOfItemInfo[index].bigPic
      if (this.bigPic != '' && this.bigPic != null) {
        this.showFullImageDialog = true
      }
    },
    openItemDetail(id) {
      console.log(id)
      // const value = JSON.stringify(id)
      // sessionStorage.setItem('ItemId', value)
      sessionStorage.setItem('mainlistPosition', this.height)

      if (globalVar.mode == 'normal') {
        this.$router.replace({ name: 'ItemDetail', params: { itemId: id } })
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({
          name: 'ItemDetail',
          params: { mchdCode: mchCd, itemId: id }
        })
      }
    },
    closeFullImgDialog() {
      this.showFullImageDialog = false
    },

    addToCart(memo) {
      this.selectedPropPrice = []
      console.log('cart info: ', this.InfoOfCart)
      console.log('memo :', memo)
      this.propItemPrice = 0
      // console.log(index)
      // console.log(this.index)
      // console.log(this.ListOfItemInfo[this.index].PriceID)
      // console.log(this.ListOfItemInfo[this.index].Name)
      console.log(this.ListOfItemInfo[this.index].size)
      // console.log(this.ListOfItemInfo[this.index].qty)
      // console.log(this.singlePrice)

      if (this.selectedProp.length > 0) {
        for (let i = 0; i < this.selectedProp.length; i++) {
          for (let j = 0; j < this.ListOfItemProp.length; j++) {
            if (this.selectedProp[i] == this.ListOfItemProp[j].propName) {
              const ListOfSelectedPropDetail = []
              ListOfSelectedPropDetail.propName = this.ListOfItemProp[
                j
              ].propName
              ListOfSelectedPropDetail.propPrice = this.ListOfItemProp[
                j
              ].propPrice
              this.selectedPropPrice.push(ListOfSelectedPropDetail.propPrice)
              this.propItemPrice =
                this.propItemPrice + this.ListOfItemProp[j].propPrice
              break
            }
          }
        }
        console.log(this.selectedPropPrice)
      }

      if (memo == null) {
        memo = ''
      }

      let bFound = false
      if (
        this.ListOfItemInfo[this.index].size != '-' &&
        this.singlePrice != null
      ) {
        this.szMsg = false
        if (this.InfoOfCart.length > 0) {
          for (let i = 0; i < this.InfoOfCart.length; i++) {
            // console.log('a', this.InfoOfCart[i].PriceID)
            // console.log('b', this.ListOfItemInfo[this.index].PriceID)
            // console.log('c', this.InfoOfCart[i].size)
            // console.log('d', this.ListOfItemInfo[this.index].size)

            if (
              this.InfoOfCart[i].ItemID ==
                this.ListOfItemInfo[this.index].ItemID &&
              this.InfoOfCart[i].size == this.ListOfItemInfo[this.index].size &&
              this.InfoOfCart[i].qty != 0
            ) {
              if (
                this.InfoOfCart[i].memo != memo &&
                this.InfoOfCart[i].qty != 0
              ) {
                bFound = false
                break
              } else {
                this.InfoOfCart[i].prop = this.selectedProp
                this.InfoOfCart[i].propPrice = this.selectedPropPrice
                this.InfoOfCart[i].qty =
                  this.InfoOfCart[i].qty + this.ListOfItemInfo[this.index].qty
                this.InfoOfCart[i].propTotalPrice = this.propItemPrice
                this.InfoOfCart[i].totalPrice =
                  this.InfoOfCart[i].qty *
                  (this.InfoOfCart[i].singlePrice + this.propItemPrice)
                // this.ListOfItemInfo[this.index].totalPrice = this.InfoOfCart[i].totalPrice
                // console.log('aa', this.InfoOfCart[i].qty)
                // console.log('qty2', this.ListOfItemInfo[this.index].qty)
                // console.log('length', this.InfoOfCart.length)
                console.log('Add to Cart Item (bFound): ', this.InfoOfCart)
                bFound = true
                this.snackbar = true
                this.closeDialog()
                break
              }
            }
          }

          if (!bFound) {
            const cartItem = {
              ID: this.itemId,
              PriceID: this.ListOfItemInfo[this.index].ItemID,
              name: this.ListOfItemInfo[this.index].Name,
              desc: this.ListOfItemInfo[this.index].Description,
              size: this.ListOfItemInfo[this.index].size,
              qty: this.ListOfItemInfo[this.index].qty,
              prop: this.selectedProp,
              propPrice: this.selectedPropPrice,
              propTotalPrice: this.propItemPrice,
              memo: memo,
              singlePrice: this.singlePrice,
              totalPrice:
                (this.singlePrice + this.propItemPrice) *
                this.ListOfItemInfo[this.index].qty
            }
            this.InfoOfCart.push(cartItem)
            console.log('Add to Cart Item: ', this.InfoOfCart)

            // this.ListOfItemInfo[this.index].totalPrice = cartItem.totalPrice
            this.snackbar = true
            this.closeDialog()
          }
        } else {
          const cartItem = {
            ID: this.itemId,
            PriceID: this.ListOfItemInfo[this.index].ItemID,
            name: this.ListOfItemInfo[this.index].Name,
            desc: this.ListOfItemInfo[this.index].Description,
            size: this.ListOfItemInfo[this.index].size,
            qty: this.ListOfItemInfo[this.index].qty,
            prop: this.selectedProp,
            propPrice: this.selectedPropPrice,
            propTotalPrice: this.propItemPrice,
            memo: memo,
            singlePrice: this.singlePrice,
            totalPrice:
              (this.singlePrice + this.propItemPrice) *
              this.ListOfItemInfo[this.index].qty
          }
          this.InfoOfCart.push(cartItem)
          console.log('Add to Cart Item: ', this.InfoOfCart)

          // this.ListOfItemInfo[this.index].totalPrice = cartItem.totalPrice
          this.snackbar = true
          this.closeDialog()
        }
      } else {
        if (this.ListOfItemInfo[this.index].size == '-') {
          this.szMsg = true
          this.szMsgText = 'Notice：Please select Size and Quantity!!!'
          // this.dialog.open(ListSltSzDialog)
          // alert('This product has multiple attributes, please update in the shopping cart.')
        }
      }

      // for (let i = 0; i < this.InfoOfCart.length; i++) {
      //   if (this.InfoOfCart[i].mchtItmID == this.ListOfItemInfo[this.index].MchtItmID && this.InfoOfCart[i].size != this.ListOfItemInfo[this.index].size) {
      //     this.sameItmDiffSizeQty = this.sameItmDiffSizeQty + this.InfoOfCart[i].qty
      //     console.log('aaaaaaaaaaaaaa: ',this.InfoOfCart[i].qty)
      //     console.log('bbbbbbbbbbbbbb: ',this.sameItmDiffSizeQty)
      //     break
      //   }
      // }

      // if (this.InfoOfCart.length != 0) {
      //   this.totalPayQty = 0
      //   this.totalPayment = 0
      //   for (let i = 0; i < this.InfoOfCart.length; i++) {
      //     this.totalPayQty = this.totalPayQty + this.InfoOfCart[i].qty
      //     this.totalPayment = this.totalPayment + this.InfoOfCart[i].totalPrice
      //   }

      //   this.OrderPayment = []
      //   console.log(this.paymentItem.totalPayQty)
      //   console.log(this.totalPayQty)
      //   this.paymentItem.totalPayQty = this.totalPayQty
      //   console.log(this.paymentItem.totalPayQty)
      //   this.paymentItem.totalPayment = this.totalPayment
      //   this.OrderPayment.push(this.paymentItem)
      //   // console.log('total qty: ', this.totalPayQty)
      //   // console.log('total payment: ', this.totalPayment)
      //   console.log('payment item: ', this.OrderPayment)
      // }
      this.ListOfItemInfo[this.index].size = '-'
    },
    goLogin() {
      this.loginUName = ''
      this.loginUPswd = ''
      this.loginError = ''
      this.userLoginDialog = true
    },
    toShoppCart() {
      // const cartItem = sessionStorage.getItem('cart')
      // // console.log(cartItem)
      // this.allCartItem = JSON.parse(cartItem)
      // console.log(this.cartItem)

      // if (this.cartItem == undefined || this.cartItem.length == 0) {
      //   sessionStorage.setItem('cart', this.cartItem)
      // }

      if (this.sendRefId == 0) {
        this.createRefId()
      }

      // const value2 = JSON.stringify(this.listOfProp)
      // sessionStorage.setItem('propList', value2)
      sessionStorage.setItem('mainlistPosition', this.height)

      sessionStorage.setItem(
        'viewShoppingCart',
        JSON.stringify({ status: 'fromMainlist', itemId: '' })
      )

      if (globalVar.mode == 'normal') {
        this.$router.replace('/shopping-cart')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'ShoppCart', params: { mchdCode: mchCd } })
      }
    },
    createRefId() {
      this.sendRefId = new Date().getTime()
      console.log(this.sendRefId)
      sessionStorage.setItem('haveRefId', this.sendRefId)
    },
    viewPurchaseHistory() {
      sessionStorage.setItem('viewPurchaseHistory', 'fromMainList')

      if (globalVar.mode == 'normal') {
        this.$router.replace('/PurchaseHistory')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({
          name: 'PurchaseHistory',
          params: { mchdCode: mchCd }
        })
      }
    },
    backToBackEndOrd() {
      sessionStorage.removeItem('TotalCartItemQty')
      sessionStorage.removeItem('cart')
      sessionStorage.removeItem('sltCatName')

      if (globalVar.mode == 'normal') {
        this.$router.replace('/Backend')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({ name: 'Backend', params: { mchdCode: mchCd } })
      }
    },
    getUserCurrentInfo() {
      this.versionError = false
      var version = sessionStorage.getItem('version')
      const url = 'Order/GetUserInfo'
      const parameter = {
        av: version,
        kp: this.kp,
        m: this.userIdFromServer
      }
      console.log('parameter: ', parameter)

      JS.request(url, parameter)
        .then(response => {
          console.log('data : ', response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            this.userCurrentBalance = response.data.re

            sessionStorage.setItem(
              'successLogin',
              JSON.stringify({
                successLogin: true,
                clientDisplayName: response.data.ez,
                clientMobileNo: response.data.az,
                clientAddress: response.data.en,
                clientId: response.data.m,
                clientEmail: response.data.ly,
                clientBalancePoint: response.data.re,
                clientAddr1: response.data.rf,
                clientAddr2: response.data.rg,
                clientAddr3: response.data.rh,
                clientCity: response.data.ri,
                clientPostcode: response.data.rj,
                clientState: response.data.rk,
                clientCountryName: response.data.hm
              })
            )
          }
        })
        .catch(error => {
          this.versionError = false
          console.log(error)
        })
    },
    logOutUser() {
      sessionStorage.setItem(
        'loginData',
        JSON.stringify({
          name: '',
          pwd: ''
        })
      )

      sessionStorage.setItem(
        'successLogin',
        JSON.stringify({
          successLogin: false,
          clientDisplayName: '',
          clientMobileNo: '',
          clientAddress: '',
          clientId: '',
          clientEmail: '',
          clientBalancePoint: 0,
          clientAddr1: '',
          clientAddr2: '',
          clientAddr3: '',
          clientCity: '',
          clientPostcode: '',
          clientState: '',
          clientCountryName: ''
        })
      )

      this.successLogin = false

      sessionStorage.clear()
      this.$router.go(0)
    }
  }
}
</script>

<style>
.sellingFast {
  margin: 0px;
  text-align: left;
  border: 1px solid orange;
  border-radius: 5px;
  padding: 0px 5px 0px 5px;
  color: orange;
  font-size: 14px;
}
.badgeQty {
  margin-top: 8px;
  font-size: 9px;
  background-color: red;
  margin-left: -9px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
}

.itemPriceColor {
  padding: 5px !important;
  color: red;
}

.grid-list-xs :not(:only-child) .layout:first-child {
  margin-top: 0px !important;
}

.itemListLayout {
  padding: 2.5px;
  width: 16.66%;
  max-width: 16.66%;
}
.containTitleWidth {
  margin-top: 20px;
  margin-bottom: -2.5px;
  background-color: snow;
  margin-left: 1.5px;
  margin-right: 15px;
  padding: 10px;
}
@media (max-width: 1903px) {
  .itemListLayout {
    padding: 2.5px;
    width: 25%;
    max-width: 25%;
  }
  .containTitleWidth {
    margin-top: 20px;
    margin-bottom: -2.5px;
    background-color: snow;
    margin-left: 1.5px;
    margin-right: 10px;
    padding: 10px;
  }
}
@media (max-width: 1263px) {
  .itemListLayout {
    padding: 2.5px;
    width: 25%;
    max-width: 25%;
  }
  .containTitleWidth {
    margin-top: 20px;
    margin-bottom: -2.5px;
    background-color: snow;
    margin-left: 1.5px;
    margin-right: 8px;
    padding: 10px;
  }
}
@media (max-width: 959px) {
  .v-toolbar__content,
  .v-toolbar__extension {
    padding: 0 6px !important;
  }
  .itemListLayout {
    padding: 2.5px;
    width: 50%;
    max-width: 50%;
  }
  .containTitleWidth {
    margin-top: 20px;
    margin-bottom: -2.5px;
    background-color: snow;
    margin-left: 1.5px;
    margin-right: 5.5px;
    padding: 10px;
  }
}
.carousel {
  height: 500px !important;
}
.carousel .v-icon {
  display: none;
}
.carousel:hover .v-icon {
  display: block;
}
.v-carousel__controls {
  background: transparent !important;
}
.slideImg {
  width: 100%;
  height: auto;
}

.mainListItemBtn:hover {
  padding: 6px;
  background-color: gainsboro;
}

.mainListItemBtn {
  text-align: left;
}

.noPadding {
  padding: 0px !important;
}

.smallImgWidth {
  max-width: 450px;
  max-height: 450px;
}

.setBtnSz {
  min-width: 32px;
}

.iPrice {
  width: var(--mainList-iPrice-width);
  padding-left: var(--mainList-iPrice-padding_left);
  padding-right: var(--mainList-iPrice-padding_right);
}

.border {
  padding: var(--mainList-border-padding);
  border: var(--mainList-border-border);
  border-radius: var(--mainList-border-border_radius);
}

.qtyBtn {
  position: var(--mainList-qtyBtn-position);
  background-color: var(--mainList-qtyBtn-background_color);
  border-radius: var(--mainList-qtyBtn-border_radius);
  top: var(--mainList-qtyBtn-top);
  right: var(--mainList-qtyBtn-right);
  width: var(--mainList-qtyBtn-width);
  height: var(--mainList-qtyBtn-height);
  padding: var(--mainList-qtyBtn-padding);
}

.deleteBtn {
  position: var(--mainList-deleteBtn-position);
  top: var(--mainList-deleteBtn-top);
  right: var(--mainList-deleteBtn-right);
  width: var(--mainList-deleteBtn-width);
  height: var(--mainList-deleteBtn-height);
  padding: var(--mainList-deleteBtn-padding);
}

#fix {
  /* position: var(--mainList-fix-position); */
  bottom: var(--mainList-fix-bottom);
  background-color: var(--mainList-fix-background_color);
  position: -webkit-sticky; /* Safari */
  position: sticky;
}

.totalPayment {
  margin-top: var(--mainList-totalPayment-margin_top);
}

.imgWidth {
  width: 100%;
}

.itemTxtWidth {
  float: left;
}
@media (max-width: 1903px) {
  .carousel {
    height: 400px !important;
  }
}
@media (max-width: 1265px) {
  .carousel {
    height: 315px !important;
  }
}
@media (max-width: 959px) {
  .carousel {
    height: 250px !important;
  }
}
@media (max-width: 780px) {
  .imageContainer {
    width: 100%;
    height: auto;
  }
}
@media (max-width: 768px) {
  .carousel {
    height: 188px !important;
  }
}
@media (max-width: 555px) {
  .carousel {
    height: 180px !important;
  }
}
@media (max-width: 530px) {
  .carousel {
    height: 168px !important;
  }
}
@media (max-width: 500px) {
  .imgWidth {
    width: 100%;
  }

  .itemTxtWidth {
    width: 100%;
  }
}
@media (max-width: 450px) {
  .totalPayment {
    font-size: var(--mainList-mediaMax450-totalPayment-font_size);
    margin-top: var(--mainList-mediaMax450-totalPayment-margin_top);
  }

  h3 {
    font-size: var(--mainList-mediaMax450-h3-font_size);
  }

  h4 {
    font-size: var(--mainList-mediaMax450-h4-font_size);
  }

  .SCText {
    font-size: var(--mainList-mediaMax450-SCText-font_size);
  }
}
@media (max-width: 480px) {
  .carousel {
    height: 160px !important;
  }
}
@media (max-width: 455px) {
  .carousel {
    height: 150px !important;
  }
}
@media (max-width: 430px) {
  .carousel {
    height: 140px !important;
  }
}
@media (max-width: 399px) {
  .carousel {
    height: 130px !important;
  }
}
@media (max-width: 375px) {
  .carousel {
    height: 120px !important;
  }
}
@media (max-width: 350px) {
  .carousel {
    height: 115px !important;
  }
}
@media (max-width: 332px) {
  .carousel {
    height: 110px !important;
  }
}
@media (max-width: 319px) {
  .carousel {
    height: 105px !important;
  }
}
@media (max-width: 293px) {
  .carousel {
    height: 95px !important;
  }
}
</style>
